import { type OnDestroy, type OnInit, Component, inject } from '@angular/core';
import {FirebaseService} from '../../core/services/firebase.service';
import {FileUploadService} from '../media-upload/file-upload.service';
import {Subscription} from 'rxjs';



@Component({
    selector: 'app-home-weekly-catering',
    templateUrl: './home-weekly-catering.component.html',
    styleUrls: ['./home-weekly-catering.component.scss'],
    imports: []
})
export class HomeWeeklyCateringComponent implements OnInit, OnDestroy {
  private firebaseService = inject(FirebaseService);
  private uploadService = inject(FileUploadService);


  subscriptions: Subscription = new Subscription();
  imgUrl: string;

  ngOnInit() {
    this.imgUrl = null;
    this.subscriptions.add(
        this.uploadService.getFileList().subscribe(data => {
          this.imgUrl = data?.map(x => x.data())?.[0]?.url;
        }));
  }

  mouseEnter(_e: unknown) {
    this.firebaseService.setFloatButton(true);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
